import _ from 'lodash';
import React from 'react';

import {formatDate} from 'utils/datetime';
import Table from 'components/Table';
import Button from 'components/Button';

import arrowRight from './assets/tail-right.svg';

import './styles.css';

const renderRentScheduleRow = invoice => (
  <Table.Row key={invoice.id}>
    <Table.Cell className="dueDate">{formatDate(invoice.dueDate)}</Table.Cell>
    <Table.Cell className="rentPeriod">
      {formatDate(invoice.rentStart)}{' '}
      <img className="rightArrow" src={arrowRight} alt="Arrow pointing right" />{' '}
      {formatDate(invoice.rentEnd)}{' '}
    </Table.Cell>
    <Table.Cell className="type">{invoice.type}</Table.Cell>
    <Table.Cell className="days">{invoice.days}</Table.Cell>
    <Table.Cell className="amount">£{invoice.amount}</Table.Cell>
  </Table.Row>
);

const renderRentScheduleSummary = rentSchedule => (
  <Table.Row className="totalsRow">
    <Table.Cell />
    <Table.Cell />
    <Table.Cell className="daysCell totalDays">
      {rentSchedule.totalDays}
    </Table.Cell>
    <Table.Cell className="amountCell totalAmount">
      &pound;{rentSchedule.totalAmount}
    </Table.Cell>
  </Table.Row>
);

const RentScheduleTable = ({
  rentSchedule,
  openCreateRentScheduleModal,
  canRentScheduleBeGenerated
}) => {
  const scheduleIsEmpty = _.isEmpty(rentSchedule.schedule);

  return (
    <div className="RentScheduleTable">
      <Table>
        <Table.Header>
          <Table.HeaderItem className="dueDate" heading="Due date" />
          <Table.HeaderItem className="rentPeriod" heading="Rent period" />
          <Table.HeaderItem className="type" heading="Type" />
          <Table.HeaderItem className="days" heading="Days" />
          <Table.HeaderItem className="amount" heading="Amount due" />
        </Table.Header>
        <Table.Body>
          {rentSchedule.map(renderRentScheduleRow)}
          {!scheduleIsEmpty && renderRentScheduleSummary(rentSchedule)}
        </Table.Body>
      </Table>

      <div className="options">
        <Button
          white
          className="createPaymentSchedule"
          disabled={!canRentScheduleBeGenerated}
          onClick={openCreateRentScheduleModal}>
          Create payment schedule
        </Button>
      </div>
    </div>
  );
};

export default RentScheduleTable;
